import { render, staticRenderFns } from "./CompensationProposalApproval.vue?vue&type=template&id=55551390"
import script from "./CompensationProposalApproval.vue?vue&type=script&lang=js"
export * from "./CompensationProposalApproval.vue?vue&type=script&lang=js"
import style0 from "./CompensationProposalApproval.vue?vue&type=style&index=0&id=55551390&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports